import React from 'react';
import Header from 'components/Header';
import Container from 'components/Container';
import SignUpSection from 'components/SignUpSection';
import Button from 'components/Button';
import Footer from 'components/Footer';
import styled from 'styled-components';
import SubHeading from 'components/SubHeading';
import kjua from 'kjua';
import { COLOR } from 'config';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import media from 'utils/media';
import axios from 'axios';
import { kc, popular } from './images';

const Wrapper = styled.div`
  // margin: 0 100px;
  padding-top: 32px;
  padding-bottom: 100px;
  display: flex;
  justify-content: space-between;
  flex-direction: column-reverse;
  ${media.md.css`
  flex-direction: row-reverse;
  `}
`;

const QrCodeBox = styled.div`
  width: 300px;
  height: 300px;
  min-width: 300px;
  min-height: 300px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e0e0e0e;
  margin-bottom: 12px;

  span {
    font-size: 14px;
    font-weight: 700;
    font-family: 'SkycoinSans', sans-serif;
  }

  ${media.md.css`
  margin-bottom: 0;
  `}
`;

const AddressInput = styled.input`
  width: 100%;
  padding: 14px 0 14px 0;
  text-indent: 12px;
  border-radius: 4px;
  outline: none;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  font-family: 'SkycoinSans', sans-serif;
  margin-bottom: 15px;
  ${media.md.css`
  width: 400px;
  `}
`;

const ActionBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const QRCodeImages = styled.div`
  margin-bottom: 1em;
`;

const ImageWrapper = styled.div`
  margin-top: 2.5em;
`;

const QrCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0;
  align-items: center;
  ${media.md.css`
  margin-left: 4em;
  align-items: flex-end;
  `}
`;

const IconBox = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  background: #e0e0e0;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: opacity 250ms ease-in-out;
  img {
    width: 100%;
  }

  &:hover {
    opacity: 0.65;
  }
`;

const Types = styled.div`
  display: flex;
  margin: 12px 0;
`;

const Type = styled.button`
  padding: 8px 16px;
  border-radius: 25px;
  font-size: 10px;
  font-weight: 700;
  outline: none;
  background: ${props => (props.checked ? COLOR.base : COLOR.white)};
  color: ${props => (props.checked ? COLOR.white : COLOR.dark)};
  margin-right: 8px;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  border-color: ${props => (props.checked ? 'transparent' : '#e0e0e0')};
  transition: background 200ms ease-in-out;

  &:hover {
    background: ${props => (props.checked ? COLOR.base : '#e0e0e0')};
  }
`;

const CheckIcon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background: ${COLOR.base};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
`;

const Message = styled.p`
  font-size: 12px;
  font-family: 'SkycoinSans', sans-serif;
  color: ${props => (props.color ? props.color : 'red')};
  margin-top: 4px;
  margin-bottom: 8px;
  margin-left: 2px;
`;

export const Icon = props => (
  <FontAwesomeIcon
    icon={props.icon}
    style={{ color: COLOR.white, fontSize: '12px' }}
  />
);

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
};

class QRCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      generated: false,
      address: '',
      iconSets: 'popular',
      chosenIcon: '',
      chosenImageIcon: '',
      addressError: false,
      addressErrorMessage: '',
      loading: false,
      amount: '',
      notes: '',
    };
  }

  generateQrCode = () => {
    let el;
    this.setState({ loading: true, addressError: false });
    if (!this.state.address) {
      this.setState({
        addressError: true,
        loading: false,
        addressErrorMessage: 'This field is required',
      });
      return;
    }

    let address = this.state.address;
    const amount = Number(this.state.amount);
    if (amount && this.state.notes) {
      address = `${address}?amount=${amount}&message=${this.state.notes}`;
    } else if (amount) {
      address = `${address}?amount=${amount}`;
    } else if (this.state.notes) {
      address = `${address}?message=${this.state.notes}`;
    }

    axios
      .post(
        'https://node.skycoin.com/api/v2/address/verify',
        { address: this.state.address },
        { headers: { 'content-type': 'application/json' } },
      )
      .then(res => res.status)
      .then(() => {
        if (this.state.chosenImageIcon) {
          const img = new Image();
          img.src = this.state.chosenImageIcon;
          img.crossOrigin = 'anonymous';
          img.style.border = '3px solid white';
          img.onload = () => {
            el = kjua({
              render: 'image',
              crisp: !0,
              minVersion: 1,
              ecLevel: 'H',
              size: 300,
              ratio: null,
              fill: '#000000',
              back: '#fff',
              text: `skycoin:${address}`,
              rounded: 80,
              quiet: 1,
              mode: 'image',
              mSize: 30,
              mPosX: 50,
              mPosY: 50,
              label: 'no label',
              fontname: 'sans',
              fontcolor: '#333',
              image: img,
            });
            const qrCodeEl = document.getElementById('qr-code');
            while (qrCodeEl.firstChild) {
              qrCodeEl.removeChild(qrCodeEl.firstChild);
            }
            qrCodeEl.appendChild(el);
          };
        } else {
          el = kjua({
            render: 'image',
            crisp: true,
            minVersion: 1,
            ecLevel: 'H',
            size: 300,
            ratio: null,
            fill: '#000000',
            back: '#fff',
            text: `skycoin:${address}`,
            rounded: 80,
            quiet: 1,
            uri: 'skycoin',
            mode: 'plain',
            mSize: 40,
            mPosX: 50,
            mPosY: 50,
            label: 'no label',
            fontname: 'sans',
            fontcolor: '#333',
          });

          const qrCodeEl = document.getElementById('qr-code');
          while (qrCodeEl.firstChild) {
            qrCodeEl.removeChild(qrCodeEl.firstChild);
          }
          qrCodeEl.appendChild(el);
        }
        this.setState({ addressError: false, loading: false });
      })
      .catch((err) => {
        this.setState({
          addressError: true,
          addressErrorMessage: err.response.data.error.message,
          loading: false,
        });
      });
  };

  downloadQrCode = () => {
    if (!this.state.address) {
      return;
    }

    const qrEl = document.querySelector('#qr-code img');
    const a = document.createElement('a');
    a.href = qrEl.getAttribute('src');
    a.download = `QRCode-${this.state.address}.png`;
    a.click();
  };

  addressOnChange = (e) => {
    this.setState({ address: e.target.value });
  };

  amountOnChange = (e) => {
    this.setState({ amount: e.target.value });
  };

  notesOnChange = (e) => {
    this.setState({ notes: e.target.value });
  };

  pickSet = (setName) => {
    this.setState({ iconSets: setName });
  };

  pickIcon = (img) => {
    if (this.state.chosenIcon === img.name) {
      this.setState({ chosenIcon: '', chosenImageIcon: '' });
    } else {
      this.setState({ chosenIcon: img.name, chosenImageIcon: img.src });
    }
  };

  render() {
    return (
      <div>
        <Header border />
        <Container>
          <Wrapper>
            <QrCodeContainer>
              <QrCodeBox id="qr-code">
                <span>QR Code</span>
              </QrCodeBox>
              <Button
                color="base"
                bg="white"
                mt="8px"
                width="326px"
                onClick={this.downloadQrCode}
              >
                Download QR Code
              </Button>
            </QrCodeContainer>
            <ActionBox>
              <SubHeading heavy as="h5" mb={'10px'} fontSize={2} color="black">
                Skycoin Address
              </SubHeading>
              <AddressInput
                placeholder="Your address..."
                value={this.state.address}
                onChange={this.addressOnChange}
              />
              {this.state.addressError && (
                <Message>{this.state.addressErrorMessage}</Message>
              )}
              {this.state.loading && (
                <Message color="#313131">Validating address...</Message>
              )}

              <SubHeading
                heavy
                as="h5"
                mt={4}
                mb={'10px'}
                fontSize={2}
                color="black"
              >
                Skycoin Amount{' '}
                <span style={{ color: '#767676', textTransform: 'none' }}>
                  (Optional)
                </span>
              </SubHeading>
              <AddressInput
                type="number"
                placeholder="Your skycoin amount..."
                value={this.state.amount}
                onChange={this.amountOnChange}
              />

              <SubHeading
                heavy
                as="h5"
                mt={4}
                mb={'10px'}
                fontSize={2}
                color="black"
              >
                Notes{' '}
                <span style={{ color: '#767676', textTransform: 'none' }}>
                  (Optional)
                </span>
              </SubHeading>
              <AddressInput
                type="text"
                placeholder="Notes..."
                value={this.state.notes}
                onChange={this.notesOnChange}
              />

              <Button
                color="white"
                bg="base"
                mt="16px"
                width={['100%', '100%', '402px']}
                onClick={this.generateQrCode}
              >
                Generate QR Code
              </Button>
              <ImageWrapper>
                <SubHeading heavy as="h5" mb={4} fontSize={2} color="black">
                  Choose An Icon{' '}
                  <span style={{ color: '#767676', textTransform: 'none' }}>
                    (Optional)
                  </span>
                </SubHeading>
                <Types>
                  <Type
                    checked={this.state.iconSets === 'popular'}
                    onClick={() => this.pickSet('popular')}
                  >
                    Popular
                  </Type>
                  <Type
                    checked={this.state.iconSets === 'kitty-cash'}
                    onClick={() => this.pickSet('kitty-cash')}
                  >
                    Kitty Cash
                  </Type>
                </Types>
                <QRCodeImages>
                  {this.state.iconSets === 'kitty-cash' &&
                    kc.map(image => (
                      <IconBox
                        key={image.name}
                        onClick={() => this.pickIcon(image)}
                      >
                        {this.state.chosenIcon === image.name && (
                          <CheckIcon>
                            <Icon icon={faCheck} />
                          </CheckIcon>
                        )}
                        <img src={image.src} alt="" />
                      </IconBox>
                    ))}

                  {this.state.iconSets === 'popular' &&
                    popular.map(image => (
                      <IconBox
                        key={image.name}
                        onClick={() => this.pickIcon(image)}
                      >
                        {this.state.chosenIcon === image.name && (
                          <CheckIcon>
                            <Icon icon={faCheck} />
                          </CheckIcon>
                        )}
                        <img src={image.src} alt="" />
                      </IconBox>
                    ))}
                </QRCodeImages>
              </ImageWrapper>
            </ActionBox>
          </Wrapper>
        </Container>
        <SignUpSection />
        <Footer />
      </div>
    );
  }
}

export default QRCode;



// WEBPACK FOOTER //
// ./src/components/QRCode/QRCode.js